// TabPanel Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

class TabPanel extends Component {
  static get propTypes () {
    return {
      active: PropTypes.bool,
      children: PropTypes.node
    }
  }

  static get defaultProps () {
    return {
      active: false
    }
  }

  render () {
    const className = classnames('tab-panel', {
      tabactive: this.props.active
    })

    return <div className={className}>{this.props.children}</div>
  }
}

export default TabPanel
